var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      on: {
        mouseleave: function($event) {
          _vm.handleMouseleaveNavTab()
        }
      }
    },
    [
      _c(
        "ul",
        {
          staticClass: "nav nav-tabs",
          staticStyle: { position: "relative" },
          attrs: { id: "warehouse-across-tabs" },
          on: {
            mouseover: function($event) {
              _vm.handleMouseoverNavTab()
            },
            mouseleave: function($event) {
              _vm.handleMouseleaveNavTab()
            }
          }
        },
        [
          _vm._l(_vm.navTabs, function(item) {
            return _c(
              "li",
              {
                key: item.id,
                staticClass: "nav-item",
                class: _vm.hoverNavTabItem(item),
                on: {
                  mouseover: function($event) {
                    _vm.handleMouseoverNavTabItem($event, item)
                  },
                  click: function($event) {
                    _vm.handleMouseleaveNavTab()
                  }
                }
              },
              [
                _c(
                  "router-link",
                  {
                    class: _vm.activeTab(item.id),
                    attrs: {
                      to: {
                        name: "Warehouse across",
                        params: {
                          tab: item.id,
                          subTab: item.childs.length ? item.childs[0].id : null
                        }
                      }
                    }
                  },
                  [_vm._v(_vm._s(item.name))]
                )
              ],
              1
            )
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isShowDropdownMenu,
                  expression: "isShowDropdownMenu"
                }
              ],
              staticClass: "dropdown-menu"
            },
            _vm._l(_vm.dropdownMenuData.childs, function(child) {
              return _c(
                "div",
                {
                  key: child.id,
                  staticClass: "dropdown-menu-item text-size-16",
                  on: {
                    click: function($event) {
                      _vm.handleClickSubMenu(child)
                    }
                  }
                },
                [
                  _c(
                    "a",
                    {
                      class: _vm.isDisableItem(child),
                      style: child.disabled
                        ? ""
                        : "text-decoration: underline;",
                      attrs: { disabled: child.disabled }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(child.name) +
                          "\n          " +
                          _vm._s(child.disabled ? "（Coming Soon）" : "") +
                          "\n          "
                      ),
                      !child.disabled
                        ? _c("i", {
                            staticClass: "fa fa-angle-right",
                            attrs: { "aria-hidden": "true" }
                          })
                        : _vm._e()
                    ]
                  )
                ]
              )
            }),
            0
          )
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4c6981ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c6981ba","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/warehouseAcross/NavTabs.vue
// module id = null
// module chunks = 